export enum ERolesEnum {
    admin = 'admin',
    user = 'user',
    manager = 'manager',
    moderator = 'moderator',
    superadmin = 'superadmin'
}

export enum ERolesPageEnum {
    owner = 'owner',
    guest = 'guest'
}

export enum EProfileType {
    'User',
    'Relative'
}
